import React from "react";
import * as styles from "./BodypartSelector.module.scss";
import classNames from "classnames";
import { useField } from "formik";
import { Col, Container, Row } from "react-bootstrap";
import FieldArrayHelper from "@app/components/FormikHelper/FieldArrayHelper";
import { DefaultCheckBox } from "@app/components/Checkbox/Checkbox";
import BodySVG from "@app/components/BodypartSelector/BodySVG";

export const bodyPartsList = ["Kopf", "Rumpf/Körper", "Arme/Hände", "Beine/Füße", "Lunge", "Augen", "Ohren"];

const BodypartSelector = (props) => {
	const { name, options, label } = props;
	const BodypartSelectorClassName = classNames({
		[styles["bodypart-selector"]]: true,
	});
	const [{ value = [] }, meta] = useField({ name });
	return (
		<div className={BodypartSelectorClassName}>
			<Container>
				<Row className={styles["attributes-row"]}>
					<Col xs={12} sm={6}>
						{label && <label className={styles.label}>{label}</label>}
						<FieldArrayHelper
							name={name}
							// renderRowAndCols={true}
							// itemsProRow={2}
							// renderGrid={false}
							components={options.map(({ label, value: fieldValue }) => (
								<DefaultCheckBox
									key={fieldValue}
									name={name}
									id={`${name}_${fieldValue}`}
									label={label}
									value={fieldValue}
									selected={value.includes(fieldValue)}
								/>
							))}
						/>
					</Col>
					<Col xs={12} sm={6}>
						<BodySVG parts={value} />
					</Col>
				</Row>
				{meta.error && (
					<Row>
						<Col>{meta.error}</Col>
					</Row>
				)}
			</Container>
		</div>
	);
};

BodypartSelector.propTypes = {};

export default BodypartSelector;
